<template>
  <div v-if="enable">
    <b-img @click="toggle" :src="getImage(actualLanguage)"></b-img>
    <div
      ref="menu"
      :style="{ display: showed ? 'block' : 'none' }"
      class="menu-dropdown"
    >
      <b-img
        @click="changeLocale(language)"
        v-for="language in languages"
        :key="language"
        :src="getImage(language)"
      ></b-img>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showed: false
    };
  },
  computed: {
    languages() {
      return this.$store.getters.getLanguages;
    },
    actualLanguage() {
      return this.$locales.lang.actual;
    },
    enable() {
      return this.languages && this.languages.length > 1;
    },
  },
  methods: {
    getImage(name) {
      return "/locales/images/" + name + ".svg";
    },
    show() {
      this.showed = true;
    },
    hide() {
      this.showed = false;
    },
    toggle() {
      this.showed = !this.showed;
    },
    changeLocale(lang) {
      this.$locales.changeLocale(lang);
      this.hide();
    },
  },
};
</script>

<style scoped>
.menu-dropdown {
  display: none;
  position: fixed;
  padding: 5px 10px;
  background: white;
  border: solid 1px gray;
  z-index: 99999;
  transform: translate(-10px, 10px);
  border-radius: 10px;
}
img {
  display: block;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.menu-dropdown * {
  margin: 5px 1px;
}
</style>
